var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Transform } from 'class-transformer';
import { ArrayMaxSize, IsArray, IsBoolean, IsIn, IsInt, IsOptional } from 'class-validator';
export const statsManfreditesQueryLocationValues = [
    'Madrid',
    'Barcelona',
    'Valencia',
    'Sevilla',
    'Zaragoza',
    'Málaga',
    'Murcia',
    'Palma',
    'Bilbao',
    'Alicante',
    'Valladolid',
    'Córdoba',
    'Coruña',
    'Granada',
    'Oviedo',
    'San Sebastián',
    'Santander',
    'Gijón',
    'Logroño',
    'Las Palmas de Gran Canaria',
    'Vigo',
    'Tarragona',
    'Burgos',
    'Almería',
    'Albacete',
    'León',
    'Salamanca',
    'Huelva',
    'Jaén',
    'Castellón'
];
export class StatsManfreditesQueryRequest {
    static _OPENAPI_METADATA_FACTORY() {
        return { techIds: { required: true, type: () => [Number] }, roleId: { required: true, type: () => Number }, withFluentEnglish: { required: true, type: () => Boolean }, location: { required: false, type: () => Object, enum: statsManfreditesQueryLocationValues } };
    }
}
__decorate([
    IsArray(),
    IsInt({ each: true }),
    ArrayMaxSize(2),
    Transform(({ value }) => value?.split(',').map(Number)),
    __metadata("design:type", Array)
], StatsManfreditesQueryRequest.prototype, "techIds", void 0);
__decorate([
    IsInt(),
    Transform(({ value }) => Number(value)),
    __metadata("design:type", Number)
], StatsManfreditesQueryRequest.prototype, "roleId", void 0);
__decorate([
    IsBoolean(),
    Transform(({ value }) => value === 'true' || value === true),
    __metadata("design:type", Boolean)
], StatsManfreditesQueryRequest.prototype, "withFluentEnglish", void 0);
__decorate([
    IsOptional(),
    IsIn(statsManfreditesQueryLocationValues),
    __metadata("design:type", String)
], StatsManfreditesQueryRequest.prototype, "location", void 0);
//# sourceMappingURL=stats-manfredites.query.request.js.map